import React,{ useState, useImperativeHandle} from 'react';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import { delProject } from '../../../../actions/majorProjects';
import BasicInfo from './basicInfo/index';
import Platform from './platform/index';
import './index.scss';

//项目信息页面
const { confirm } = Modal
const ProjectsInfoModal = (props) => {

    const tabs = [
        {
            title: '基本信息',
            selected: true,
        },
        // {
        //     title: '拟发平台',
        //     selected: false
        // }
    ];

    const [tab, setTab] = useState(tabs);
    const [currentTab, setCurrentTab]  = useState(0);
    const [visible, setVisible] = useState(false);

    useImperativeHandle(props.refs, () => ({
        changeProjectsInfoModalVisible: changeProjectsInfoModalVisible
    }))

    const changeProjectsInfoModalVisible = (visible) => {
        setVisible(visible);
    }

    const handleCancel = () => {
        changeProjectsInfoModalVisible(false);
        setCurrentTab(0);
    }

    const handleOk = () => {
        handleCancel();
    }

    const changeTab= (index) => {
        setCurrentTab(index);
    }

    const renderTabContent = (currentTab) => {
        switch(currentTab){
            case 0 : return <BasicInfo />;
            case 1 : return <Platform />;
            default: break;
        }
    }

    const edit = () => {
        handleCancel();
        props.changeProjectListModalVisible(false);
        props.addOrUpdateModal.current.changeAddModalVisible(true);
        props.changeModalTitle('编辑项目');
    }

    const deltePro = (id) => {
        confirm({
            className: 'delete_dialog',
            title: '提示',
            content: '确定删除此项目？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk(){
                delProject({id},(res) => {
                    if(res === true){
                        props.search(1,props.params);
                        props.resetData();
                        props.changeProjectListModalVisible(false);
                        setVisible(false)
                    }
                })
            }
        })
    }
  
    return(
        <Modal 
            className="project-basicinfo-modal"
            width='60%'
            visible={visible}
            onCancel={handleCancel}
            onOk={handleOk}
            destroyOnClose
            footer={null} 
        >
            <div className="project-basicinfo">
                <div className="project-basicinfo-title">
                    {
                        tab.map((item, index) => (<span className={`${currentTab === index ? 'selected' : ''}`} onClick={() => { changeTab(index) }} key={index}>{item.title}</span>))
                    }
                </div>
                <div className="project-basicinfo-wrap">
                    {
                        renderTabContent(currentTab)
                    }

                </div>
                {
                    <div className="project-basicinfo-footer">
                    <span onClick={edit}>编辑</span>
                    <span onClick={ () => deltePro(props.item.id)}>删除</span>
                </div>
                }
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => {
    return{
        
    }
}

const mapDispatchToProps = (dispatch) => {
    return{
        changeModalTitle: (value) => dispatch({type: 'CHANGE_MODAL_TITLE', payload: value}),
        changeProjectName: (value) => dispatch({type: 'CHANGE_PROJECT_NAME', payload: value}),
        changeProjectCreater: (value) => dispatch({type:'CHANGE_PROJECT_CREATER',payload: value}),
        changeProjectContent: (value) => dispatch({type:'CHANGE_PROJECT_CONTENT', payload: value}),
        resetData: () => dispatch({ type: 'RESET_DATA'})

    }

}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsInfoModal)